import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useChCreateMeasLaboratoryPrescriptionMutation as useChCreateMeasLaboratoryPrescriptionMutationType } from "@/modules/patients/detail/meas-laboratory-prescription/ch/services/__generated__/useChCreateMeasLaboratoryPrescriptionMutation.graphql"

const mutation = graphql`
  mutation useChCreateMeasLaboratoryPrescriptionMutation($input: Ch_createMeasLaboratoryPrescriptionInput!) {
    ch_createMeasLaboratoryPrescription(input: $input) {
      ch_MeasLaboratoryPrescription {
        id
        ...chMeasLaboratoryPrescriptionFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useChCreateMeasLaboratoryPrescriptionMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChCreateMeasLaboratoryPrescriptionMutationType>(
    mutation,
    params,
  )

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChCreateMeasLaboratoryPrescriptionMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChCreateMeasLaboratoryPrescriptionMutation }
